'use client'

import React from 'react'
import { useShare } from '@/hooks/useShare'

type Props = {
  children: React.JSX.Element
  title?: string
  description?: string | null
  image?: string
  url?: string
}

export const Shareable = ({ children, title, description, url }: Props) => {
  const share = useShare({ title, description, url })

  return React.cloneElement(children, { onClick: share })
}
